module.exports = __webpack_public_path__ + "static/cs22-675daebfd6c2bb4240956e041f63dcc2.jpg";